import {Badge, Icon} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export const ZahavTransferBadge: FC = () => {
  const {t} = useTranslation('trustAccounts');

  return (
    <Badge variant="warning" size="sm">
      <Icon name="zap" className="size-3" />
      {t('view.instructions.transferTypes.zahav')}
    </Badge>
  );
};
